import React, { forwardRef } from 'react';
import MaterialIconButton from '@material-ui/core/IconButton';

const IconButton = forwardRef((props, ref) => {
    const attrs = { ref };

    return <MaterialIconButton {...attrs} {...props} />;
});

IconButton.displayName = 'NeptuneIconButton';
IconButton.propTypes = { ...MaterialIconButton.propTypes };

export default IconButton;
